import React from 'react'
import { PageFooter, AppToolbar } from '../../components'
import { Outlet } from 'react-router-dom'
import { Container, Grid } from '@mui/material'
import { useStyles } from './style'

const PrimaryTemplate = () => {
  const classes = useStyles()
  return (
    <>
      <Container className={classes.appBarContainer} maxWidth={false} id='appbar-container'>
        <AppToolbar />
      </Container>
      <Grid
        container
        direction='column'
        wrap='nowrap'
        className={classes.container}
      >
        <Grid item className={classes.mainContainer}>
          <main>
            <Outlet />
          </main>
        </Grid>
        <Grid item className={classes.footerContainer}>
          <footer>
            <PageFooter />
          </footer>
        </Grid>
      </Grid>
    </>
  )
}

export default PrimaryTemplate
